import React, { useState } from 'react';
import { changeInitialPassword, MIN_PASSWORD_LENGTH } from './loginResponse';

// First sign-in with a password an administrator set: the person chooses their own before anything else opens.
export default function SetYourPassword({ changeToken, apiUrl, onSignedIn, onBack }) {
  const [password, setPassword] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < MIN_PASSWORD_LENGTH) { setError(`Use at least ${MIN_PASSWORD_LENGTH} characters.`); return; }
    if (password !== again) { setError('The two passwords are not the same.'); return; }
    setBusy(true);
    const result = await changeInitialPassword(apiUrl, changeToken, password);
    setBusy(false);
    if (result.ok) { await onSignedIn(result.data); return; }
    if (result.reason === 'expired') { onBack(result.message); return; }
    setError(result.message);
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="set-your-password">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Choose your own password</h1>
        <p className="text-sm text-gray-600 mt-1">
          Your administrator gave you a temporary password. Choose one only you know to continue.
        </p>
      </div>
      {error && <div role="alert" className="bg-red-50 text-red-600 px-4 py-3 rounded-lg text-sm">{error}</div>}
      <div>
        <label htmlFor="new-password-input" className="block text-sm font-medium text-gray-700 mb-2">New password</label>
        <input id="new-password-input" type="password" autoComplete="new-password" value={password}
          onChange={(e) => setPassword(e.target.value)} required minLength={MIN_PASSWORD_LENGTH}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg" data-testid="new-password" />
      </div>
      <div>
        <label htmlFor="new-password-again-input" className="block text-sm font-medium text-gray-700 mb-2">Type it again</label>
        <input id="new-password-again-input" type="password" autoComplete="new-password" value={again}
          onChange={(e) => setAgain(e.target.value)} required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg" data-testid="new-password-again" />
      </div>
      <button type="submit" disabled={busy}
        className="w-full min-h-[44px] bg-blue-600 text-white rounded-lg disabled:opacity-60" data-testid="set-password-submit">
        {busy ? 'Saving…' : 'Save and continue'}
      </button>
      <button type="button" onClick={() => onBack()} className="min-h-[44px] px-2 text-sm text-blue-600 hover:underline">
        Back to sign in
      </button>
    </form>
  );
}
